var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowntimelogSideicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.7085C13.5917 12.7085 13.4334 12.6502 13.3084 12.5252L10.35 9.56686L9.44169 10.9335C9.34169 11.0919 9.16669 11.1919 8.98335 11.2085C8.79169 11.2252 8.60835 11.1585 8.48335 11.0252L5.81669 8.35853C5.57502 8.11686 5.57502 7.71686 5.81669 7.4752C6.05835 7.23353 6.45835 7.23353 6.70002 7.4752L8.82502 9.6002L9.73335 8.23353C9.83335 8.08353 10 7.98353 10.1917 7.95853C10.3834 7.94186 10.5667 8.00853 10.6917 8.14186L14.1917 11.6419C14.4334 11.8835 14.4334 12.2835 14.1917 12.5252C14.0667 12.6502 13.9084 12.7085 13.75 12.7085Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.7082H12.0833C11.7416 12.7082 11.4583 12.4248 11.4583 12.0832C11.4583 11.7415 11.7416 11.4582 12.0833 11.4582H13.125V10.4165C13.125 10.0748 13.4083 9.7915 13.75 9.7915C14.0916 9.7915 14.375 10.0748 14.375 10.4165V12.0832C14.375 12.4248 14.0916 12.7082 13.75 12.7082Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.9582H7.50002C2.97502 18.9582 1.04169 17.0248 1.04169 12.4998V7.49984C1.04169 2.97484 2.97502 1.0415 7.50002 1.0415H12.5C17.025 1.0415 18.9584 2.97484 18.9584 7.49984V12.4998C18.9584 17.0248 17.025 18.9582 12.5 18.9582ZM7.50002 2.2915C3.65835 2.2915 2.29169 3.65817 2.29169 7.49984V12.4998C2.29169 16.3415 3.65835 17.7082 7.50002 17.7082H12.5C16.3417 17.7082 17.7084 16.3415 17.7084 12.4998V7.49984C17.7084 3.65817 16.3417 2.2915 12.5 2.2915H7.50002Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntimelogSideicon);
export default __webpack_public_path__ + "static/media/Downtime log - side icon.d9da165e94cb97afc1b66feed571e6be.svg";
export { ForwardRef as ReactComponent };